import { ICmsBanner } from 'banner/types/cmsBanner';

export const getCmsBanner = (cmsBanners: ICmsBanner[], segmentIds: string[]) => {
  const authorizedBanners = cmsBanners?.filter((banner: ICmsBanner) => {
    return !banner?.segmentId || segmentIds?.includes(banner?.segmentId);
  });

  const sortedAuthorizedBanners = authorizedBanners?.sort((banner1, banner2) => {
    if (banner1.segmentId && !banner2.segmentId) return -1;
    if (!banner1.segmentId && banner2.segmentId) return 1;
    return 0;
  });

  return sortedAuthorizedBanners;
};
